import { render, staticRenderFns } from "./Shopware6.vue?vue&type=template&id=5dd71259&"
import script from "./Shopware6.vue?vue&type=script&lang=js&"
export * from "./Shopware6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports